"use client";
import { SearchTypes } from "@/declarations/search";
import Button from "@/components/design-system/button";
import { FunctionComponent, useState } from "react";
import ReactMarkdown from "react-markdown";
import styles from "./moreAbout.module.scss";

const MoreAbout: FunctionComponent<MoreAboutProps> = ({ moreAboutItem }) => {
  const [showContent, setShowContent] = useState<boolean>(false);

  return (
    <div className={`${styles.moreAbout} ${showContent ? styles.active : ""} mb-3`}>
      <h3>{moreAboutItem.detailHeader}</h3>
      <div className={`${showContent ? "d-block" : "d-none"} pt-1 pb-2`}>
        <ReactMarkdown>{moreAboutItem.detailBody}</ReactMarkdown>
      </div>
      <Button
        variant="tertiary"
        color="blue"
        text={showContent ? "Less" : "More"}
        showLeftIcon={false}
        showRightIcon={false}
        onClick={() => setShowContent(!showContent)}
      />
    </div>
  );
};

export type MoreAboutProps = {
  moreAboutItem: SearchTypes.MoreAbout;
};

export default MoreAbout;
